// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Ry0_P","name":"Header_name__DgzL0","birthday":"Header_birthday___SWG6","skeleton":"Header_skeleton__KvT15"};